import { useEffect } from "react";
import { useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignUpForm from "../../components/auth/SignUpForm";
import { authService } from "../../services/authService";

export default function SignUp() {
  const navigate = useNavigate();

  useEffect(() => {
    // Verifica se o usuário já está autenticado
    if (authService.isAuthenticated()) {
      // Redireciona para a dashboard
      navigate("/");
    }
  }, [navigate]);

  return (
    <>
      <PageMeta
        title="Cadastro - Sellyo"
        description="Faça seu cadastro para gerenciar suas vendas e produtos"
      />
      <AuthLayout>
        <SignUpForm />
      </AuthLayout>
    </>
  );
}
